import React from "react";
import styled from "styled-components";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import calendarIcon from "../../assets/images/ico_calendar.png";

const StyledDiv = styled.div`
  &&& {
    display: flex;
    justify-content: center;
  }
`;

const StyledInput = styled.input`
  &&& {
    height: 34px;
    background-color: #e5f3ff;
    border: none;
    width: 110px;
    cursor: pointer;
    padding-left: 10px;
  }
`;

const CustomInput = React.forwardRef((props, ref) => {
  return (
    <div>
      <StyledInput
        {...props}
        ref={ref}
        onKeyDown={(e) => e.preventDefault()}
        readOnly
      />
      <img
        style={{
          position: "absolute",
          right: "10px",
          top: "9px",
          cursor: "pointer",
        }}
        src={calendarIcon}
        alt="cal"
        onClick={props.onClick}
      />
    </div>
  );
});

const CustomDatePicker = ({
  defaultDate,
  minDate,
  maxDate,
  onChange,
  dateFormat,
}) => {
  return (
    <StyledDiv>
      <DatePicker
        selected={defaultDate}
        minDate={minDate}
        maxDate={maxDate}
        onChange={onChange}
        dateFormat={dateFormat}
        customInput={<CustomInput />}
        renderCustomHeader={({
          date,
          decreaseMonth,
          increaseMonth,
          decreaseYear,
          increaseYear,
        }) => (
          <div style={{ display: "flex", justifyContent: "center" }}>
            <button onClick={decreaseYear}>{"<<"} &nbsp;&nbsp;</button>
            <button onClick={decreaseMonth}>{"<"} &nbsp;&nbsp;</button>
            <span>
              {date.getFullYear()}&nbsp;&nbsp;{" "}
              {date.toLocaleString("en", { month: "long" })}
              &nbsp;&nbsp;
            </span>
            <button onClick={increaseMonth}>{">"} &nbsp;&nbsp; </button>
            <button onClick={increaseYear}>{">>"}</button>
          </div>
        )}
      />
    </StyledDiv>
  );
};

export default CustomDatePicker;
